import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ScreeningService } from '../services/screening.service';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PhonePipe } from '../pipes/phone.pipe';
import { Question } from '../models/Question';

@Component({
  selector: 'app-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.less']
})
export class DemographicsComponent implements OnInit {
  @ViewChild("inputs", { static: true }) el : ElementRef;

  noMiddleName : boolean;
  noMiddleNameText : string = 'I do not have a middle name.';
  mobileOverride : boolean = true;
  stateArray : Array<string> = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT',
    'NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

  constructor(public phone : PhonePipe, private screeningSrv : ScreeningService,private location : Router, private auth : AuthService) { 
    this.auth.titleBarText = "Tell us about yourself"
    this.screeningSrv.questions.questionFlowComplete.subscribe((b : boolean)=>{
      if(b && !this.determineErrorState()){
       this.location.navigateByUrl('/final');
      }
    })
  }

  isPhoneQuestion(qname: string){
    // console.log('checking', qname)
    return (qname == "MobilePhone" || qname == "PhoneNumber" || qname == "Fax")
  }

  ngOnInit() {
  }
  
  togglePWShow(q : Question = null){
    if(!this.isMobile) {
      if(this.screeningSrv.questions.currentQuestion.questionType == 1){
        this.screeningSrv.questions.currentQuestion.questionType = 6;
      }else{
        this.screeningSrv.questions.currentQuestion.questionType = 1;
      }
    } else {
      if(q.questionType == 1) {
        q.questionType = 6;
      } else {
        q.questionType = 1;
      }
    }
  }

  ngAfterViewInit(): void {
    this.el.nativeElement.focus();
  }
  continue(){
    if(this.isMobile()) {
      this.screeningSrv.questions.Questions.forEach(q => {
        this.screeningSrv.questions.currentQuestion = q;
        console.log(q);
        this.screeningSrv.questions.moveNext();
      });
    } else {
      // TODO: have the question service move to next question in this flow.
      if(this.screeningSrv.continue())
      {
        console.log('switched questions')
      }else{
        console.log('something broke')
      }
      console.log(this.screeningSrv.questions);
      if(this.el)this.el.nativeElement.focus();
      // if(this.screeningSrv.questions.currentQuestion.name == 'DOB'){
      //   this.el.nativeElement.click();
      // }
    }
  }

  isMobile() : boolean {
    if(this.mobileOverride) return true;
      var ua = navigator.userAgent;
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
         return true;
      else if(/Chrome/i.test(ua))
         return false;
      else
         return false;
  };

  determineErrorState() : boolean {
    let x = this.screeningSrv.questions.Questions.map((q) => {
      if(q.errorOnQuestion) return true;
      return false;
    });
    let errorEntries = x.filter((e) => { return  e == true });
    if(errorEntries.length > 0) return true;
    return false;
  }

  back(){
    this.screeningSrv.questions.moveBack();
  }
  update(val : any){
    console.log(val)
    console.log(this.screeningSrv.questions);
    if(!this.isMobile) {
      this.screeningSrv.questions.currentQuestion.set(val)
    } else {
      //if it's the mobile screening, we have to manually set the current question to true in order to bind it 
      //otherwise, the value will set to the first question in the list, which is the 'current question' for mobile layout
      //this is currently hte only bool question, so this will work until that changes.
      let q = this.screeningSrv.questions.Questions.filter((q) => { return q.questionType == 5 });
      this.screeningSrv.questions.currentQuestion = q[0];
      this.screeningSrv.questions.currentQuestion.set(val);
    }
  }

  updateMiddleNameInputs() : void {
    this.screeningSrv.questions.Questions.filter((q) => { return q.name == "MiddleName" })[0].answer = null;
  }

}
